import { render, staticRenderFns } from "./DisciplineType.vue?vue&type=template&id=9c78d58a"
import script from "./DisciplineType.vue?vue&type=script&lang=js"
export * from "./DisciplineType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c78d58a')) {
      api.createRecord('9c78d58a', component.options)
    } else {
      api.reload('9c78d58a', component.options)
    }
    module.hot.accept("./DisciplineType.vue?vue&type=template&id=9c78d58a", function () {
      api.rerender('9c78d58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/DisciplineType.vue"
export default component.exports